"use strict";

const { createActor, setup } = require("xstate");
const states = require("client/pages/bicsearch/machine/states");

module.exports = function actorFactory (actions, initialContext = {}) {

    const machine = setup({
        actions: Object.assign(states.actions, actions),
        guards: {
            // "choose_tab": ({ context, event }, params) => {
            //     return context.current_tab === params.tab;
            // }
        }
    }).createMachine(states);

    return createActor(machine, {
        input: initialContext,
    }).start();
};
